import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Button from "@/components/Form/Button/Button";
import { AddDebtorFormType } from "./type";
import "./FormModal.scss";
import { isNumeric } from "@/utility/validation";
import { capitalizeWordsInSentence } from "@/utility/common";
import { renderOptionList } from "../Form/calculationSummaryHelper";
import {
  useCreateStepClassFilterApiMutation,
  useGetClassListBySchemeQuery,
  useGetSchemeVersionListByCaseQuery,
  useGetStepClassFilterByIdQuery,
  useUpdateStepClassFilterApiMutation,
} from "../calculationStepReducer";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import ChildDropdown from "../Form/ChildDropdown";
import ControlSelectScheme from "./SelectBox/ControlSelectScheme";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  formData?: AddDebtorFormType | null;
  caseId: string;
  stepId: string;
  selectedClass: string[];
  setIsRefetch: Dispatch<SetStateAction<boolean>>;
  setSelectedClassId: Dispatch<SetStateAction<string>>;
  selectedClassId: string;
  setIsEdit: any;
  selectedScheme: string | undefined;
  resolvedStatus: boolean;
};

export default function FormModalClassFilter({
  isVisible,
  setIsVisible,
  stepId,
  caseId,
  setIsRefetch,
  selectedClassId,
  setSelectedClassId,
  selectedClass,
  setIsEdit,
  selectedScheme,
  resolvedStatus,
}: Props) {
  const { t } = useTranslation();
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  let defaultOption = useMemo(
    () => ({
      label: t("global.globalActions.optionDefault"),
      value: "",
    }),
    [t]
  );
  const [isLoading, setIsLoading] = useState(false);
  const [childOptions, setChildOptions] = useState<any>([defaultOption]);

  const { data, isLoading: isLoadingData ,refetch} =
    useGetSchemeVersionListByCaseQuery(caseId);

  const {
    data: dataClass,
    isLoading: isLoadingClass,
    isFetching: isFetchingClass,
    refetch: refetchClass,
  } = useGetStepClassFilterByIdQuery(selectedClassId, {
    skip: !selectedClassId,
  });
  useEffect(()=>{
    refetch()
    refetchClass()
  },[refetch,refetchClass])
  const [schemeList, setSchemeList] = useState<any>([defaultOption]);

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors, dirtyFields },
  } = useForm<any>();
  const pageDirty = Object?.keys(dirtyFields)?.length > 0;
  const errorList = Object.keys(errors);
  const errorsShow = capitalizeWordsInSentence(errorList.join(", "));
  //@ts-ignore
  const schemeId = watch("scheme");
  useEffect(() => {
    if (data && data.length > 0) {
      const schemeList = renderOptionList(
        data,
        "name",
        "schemeVersionId",
        defaultOption
      );
      setSchemeList(schemeList);
    }
  }, [data, defaultOption]);

  //@ts-ignore
  const { data: schemeData, isLoading: schemaIsloading,isFetching:schemaFetching } =
    useGetClassListBySchemeQuery(schemeId, {
      skip: schemeId === "" || schemeId === undefined,
    });

  useEffect(() => {
    setValue("scheme", dataClass?.schemeVersionId);
    if (isVisible === true) {
      if (
        selectedScheme !== "" &&
        selectedScheme !== null &&
        selectedScheme !== undefined
      ) {
        //@ts-ignore
        // setValue("scheme", selectedScheme);
      }
    } else {
      //@ts-ignore
      // setValue("scheme", "");
      setValue("weightingFactor", 1);
    }
  }, [isVisible, selectedScheme, dataClass, setValue]);

  /* Child Dropdown */
  useEffect(() => {
    if (schemeId) {
      const filterClasses = schemeData?.filter((item: any) => {
        if (
          selectedClass === undefined ||
          selectedClass?.length === 0 ||
          selectedClass === null
        ) {
          return true;
        }
        //@ts-ignore
        if (selectedClass.includes(item.id)) {
          if (item.id === dataClass?.classId) {
            return true;
          }
          return false;
        }
        return true;
      });
      const classList = renderOptionList(
        filterClasses,
        "name",
        "id",
        defaultOption
      );
      // @ts-ignore
      setValue("weightingFactor", dataClass?.weight);
      setChildOptions(classList);
      //@ts-ignore
      setValue("class", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schemeData, selectedClassId, isVisible, dataClass]);

  useEffect(()=>{
    if(!pageDirty){
      setValue("class", dataClass?.classId);

    }

  },[childOptions,dataClass,setValue,pageDirty])

 
  /* Child Dropdown */
  let [createStepClassFilterApi] = useCreateStepClassFilterApiMutation();
  let [updateStepClassFilterApi] = useUpdateStepClassFilterApiMutation();

  const onSubmit = async (data: AddDebtorFormType) => {
    setIsLoading(true);
    try {
      const formClassData: any = data;

      let postData = {
        classId: formClassData?.class,
        weight: Number(formClassData?.weightingFactor),
      };
      // @ts-ignore
      const responseApi =
        selectedClassId === ""
          ? await createStepClassFilterApi({
              ...postData,
              caseId: caseId,
              calculationStepId: stepId,
            })
          : await updateStepClassFilterApi({
              ...postData,
              id: selectedClassId,
            });

      if (responseApi.hasOwnProperty("data")) {
        setIsRefetch(true);
        setIsVisible(false);
        setIsLoading(false);
        setSelectedClassId("");
        setChildOptions([]);
        reset();
        setIsEdit(false);
      } else {
        //@ts-ignore
        const error = responseApi.error?.data?.message || t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
        setIsLoading(false);
        setSelectedClassId("");
      }
    } catch (error) {
      setShowMessage({ ...showMessage, show: true, type: "error", message: t("global.globalNotifications.unExpectedError") });
    }
  };
  if (isLoadingData || isLoadingClass || schemaIsloading || isFetchingClass) {
    return <MotifProgressLoader show={true} />;
  }

  /* Child Dropdown */
  const onSchemeChange = () => {
    //@ts-ignore
    setValue("class", "");
  };
  /* Child Dropdown */
  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    setChildOptions([]);
    reset();
    setIsEdit(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };
  return (
    <>
      <MotifModal
        onClose={() => {
          if (pageDirty) {
            setIsVisibleCancel(true);
            setShowMessage({
              ...showMessage,
              show: false,
              type: "error",
            });
            setSelectedClassId("");
          } else {
            setIsVisible(false);
            setChildOptions([]);
            reset();
            setIsEdit(false);
            setIsVisibleCancel(false);
            setShowMessage({ ...showMessage, show: false, type: "error" });
          }
        }}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formModalWrapper">
            <MotifModalHeader>
              <span className="discard_heading">
                {t(
                  "pages.distributions.distributionStepsTab.classFilterTab.classFilterEditTitle"
                )}
              </span>
            </MotifModalHeader>
            <MotifModalBody>
              <div className="formModal">
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    {/*@ts-ignore*/}
                    <ControlSelectScheme
                      /*@ts-ignore*/
                      name={"scheme"}
                      control={control}
                      showLabel={true}
                      label={
                        "pages.distributions.distributionStepsTab.classFilterTab.scheme"
                      }
                      options={schemeList}
                      required={true}
                      setValue={setValue}
                      getValues={getValues}
                      visibleOptions={5}
                      onChangeHandler={onSchemeChange}
                      disabled={selectedScheme !== undefined || resolvedStatus}
                    />
                  </div>
                </div>
                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ChildDropdown
                      control={control}
                      //@ts-ignore
                      setValue={setValue}
                      //@ts-ignore
                      getValues={getValues}
                      name="class"
                      label="pages.distributions.distributionStepsTab.classFilterTab.class"
                      required={true}
                      options={childOptions}
                      disabled={schemaFetching || resolvedStatus}
                      visibleOptions={3}
                      />
                                    {schemaFetching && <><br></br><MotifProgressLoader size='xs' variant='circular'></MotifProgressLoader></>}
                    
                  </div>
                </div>

                <div className="motif-row mar-t-20">
                  <div className="motif-col-md-5">
                    <ControlInputBoxNumber
                      name={"weightingFactor"}
                      // @ts-ignore
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.classFilterTab.weightFactor"
                      }
                      showLabel={true}
                      // @ts-ignore
                      setValue={setValue}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumeric}
                      readonly={resolvedStatus}
                    />
                  </div>
                </div>
              </div>
              <div>
                <MotifErrorMessage>
                  {showMessage.show && showMessage.message}
                  {errorList.length > 0 &&
                    t(
                      "pages.distributions.distributionStepsTab.classFilterTab.validationMessage",
                      { fieldNames: errorsShow }
                    )}
                </MotifErrorMessage>
              </div>
            </MotifModalBody>
            <MotifModalFooter>
              <div className="button-container-add">
                <Button
                  variant={SAVE_BUTTON_VARIANT}
                  label={t("global.globalActions.save")}
                  loading={isLoading}
                  disabled={isLoading || resolvedStatus}
                />
                <Button
                  label={t("global.globalActions.cancel")}
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={(e) => {
                    if (pageDirty) {
                      setIsVisibleCancel(true);
                      setShowMessage({
                        ...showMessage,
                        show: false,
                        type: "error",
                      });
                      setSelectedClassId("");
                    } else {
                      cancelBtnApproveHandler(e);
                    }
                  }}
                />
              </div>
            </MotifModalFooter>
          </div>
        </form>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
